import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import TLabel from '~/components/atoms/t-label.vue';
import TInput from '~/components/atoms/t-input.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTextForm',
  emits: ["updateCustomText", "download"],
  setup(__props, { emit }: { emit: ({
  (event: 'updateCustomText', customText: string): void;
  (event: 'download'): void;
}), expose: any, slots: any, attrs: any }) {

const customText = ref('');



function updateCustomText(inputtedText: string) {
  const strippedCustomText = inputtedText.replace(/[^a-z0-9]+/gi, '');
  emit('updateCustomText', strippedCustomText);
}

return { __sfc: true,customText, emit, updateCustomText, TLabel, TInput }
}

})